import React from "react";
import "../../assets/styles/cards.css";

export default class OfflineCardMessage extends React.Component {
  render() {
    return (
      <div className="offline-message-wrapper">
        <div className="not-allowed bg-nl color-m f6" role="alertdialog">
          <div className="space card-bottom-msg color-n">
            <div className="">לא ניתן לצפות אונליין</div>
            <div className="">בקוד הסודי של כרטיס זה.</div>
          </div>
          <div className=" card-bottom-msg color-n">
            <span>
              להזמנת קוד סודי בדואר{" "}
              <a
                className=" color-n"
                onClick={() =>
                  this.props.onExpressToken(this.props.last4Digits)
                }
                alt="לחץ כאן להזמנת קוד סודי בדואר"
                tabIndex="0"
              >
                לחץ כאן
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/OfflineCardMessage.jsx